import React, { cloneElement, forwardRef, memo, useCallback, useImperativeHandle, useMemo, useRef, } from 'react';
import isNil from 'lodash/isNil';
const List = forwardRef(({ data, prefixCls, children, height, itemKey, }, ref) => {
    const containerRef = useRef(null);
    const innerStyle = useMemo(() => {
        const style = {
            display: 'flex',
            flexDirection: 'column',
        };
        if (height) {
            style.height = height;
            style.overflow = 'hidden auto';
        }
        return style;
    }, [height]);
    const getKey = useCallback(function (item) {
        if (typeof itemKey === 'function') {
            return itemKey(item);
        }
        return isNil(itemKey) ? undefined : item[itemKey];
    }, [itemKey]);
    const renderChild = useCallback(child => cloneElement(children(child), { key: getKey(child) }), [children, getKey]);
    const scrollTo = useCallback((scroll) => {
        const { current } = containerRef;
        if (current) {
            if (current.scrollTo) {
                current.scrollTo(0, scroll);
            }
            else {
                current.scrollTop = scroll;
            }
        }
    }, [containerRef]);
    useImperativeHandle(ref, () => ({
        scrollTo,
    }), [scrollTo]);
    return (React.createElement("div", { className: `${prefixCls}-holder` },
        React.createElement("div", { className: `${prefixCls}-holder-inner`, style: innerStyle, ref: containerRef }, data.map(renderChild))));
});
export default memo(List);
